/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2023-08-17 10:17:48
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-28 16:45:02
 */
import { RouteRecordRaw } from 'vue-router'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const AddressSetting = () => import('@/views/address/Index.vue')
const StoreManagement = () => import('@/views/storeManagement/Index.vue')
// COD统计
const codStatisticsManage: RouteRecordRaw[] = [
  // 异常支付审核
  {
    path: UrlEnum[UnionEnum.ABNORMALPAYMENT],
    name: 'AbnormalPayment',
    component: () => import('@/views/abnormalPayment/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ABNORMALPAYMENT], requiresAuth: true, keepAlive: true }
  }
]
const sysSetting: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.STOREMANAGEMENT],
    name: 'StoreManagement',
    component: StoreManagement,
    meta: { title: NameEnum[UnionEnum.STOREMANAGEMENT], requiresAuth: true, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.ADDRESS],
    name: 'AddressSetting',
    component: AddressSetting,
    meta: { title: NameEnum[UnionEnum.ADDRESS], requiresAuth: true, keepAlive: true }
  }
]
// 包裹管理
const packManage: RouteRecordRaw[] = [
  {
    path: '/orderEntry',
    name: 'OrderEntry',
    component: () => import('../views/packageManagement/orderEntry/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ORDERWRITER], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/privacyAgreement',
    name: 'PrivacyAgreement',
    component: () => import('../views/packageManagement/privacyAgreement/Index.vue'),
    meta: { title: '条款与条件', requiresAuth: false, keepAlive: true }
  },
  {
    path: UrlEnum[UnionEnum.ORDERLIST],
    name: 'OrderQuery',
    component: () => import('../views/packageManagement/orderQuery/Index.vue'),
    meta: { title: NameEnum[UnionEnum.ORDERLIST], requiresAuth: true, keepAlive: true }
  },
  {
    path: '/dispatchList',
    name: 'DispatchList',
    component: () => import('../views/packageManagement/dispatchList/Index.vue'),
    meta: { title: '派件包裹列表', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/internationalList',
    name: 'InternationalList',
    component: () => import('../views/packageManagement/International/List.vue'),
    meta: { title: '国际件', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/expressTracking',
    name: 'ExpressTracking',
    component: () => import('../views/expressTracking/Index.vue'),
    meta: { title: '快件跟踪', requiresAuth: true, keepAlive: true }
  }
  // {
  //   path: '/inquiryList',
  //   name: 'InquiryList',
  //   component: () => import('@/views/packageManagement/inquiryList/Index.vue'),
  //   meta: { title: '客户问询列表', requiresAuth: true, keepAlive: true }
  // }
]
// 资金管理
const fundManage: RouteRecordRaw[] = [
  {
    path: '/sendCommissionReport',
    name: 'SendCommissionReport',
    component: () => import('../views/fundManage/sendCommissionReport/Index.vue'),
    meta: { title: '寄件提成报表', requiresAuth: true, keepAlive: true }
  },
  {
    path: '/performanceReward',
    name: 'PerformanceReward',
    component: () => import('../views/fundManage/performance-reward/performanceReward.vue'),
    meta: { title: '冲单奖励', requiresAuth: true, keepAlive: true }
  }
]
export { codStatisticsManage, sysSetting, packManage, fundManage }
